import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { isEmail } from '@sainsburys-tech/bolt-validators'
import { InfoIcon } from '@sainsburys-tech/bolt-icons'
import * as Styled from './DeliveryEmailForm.styles'

const getErrorMessage = validEmail => {
  if (!validEmail) return 'Please enter a valid email'
  return ''
}

const DeliveryEmailForm = ({ dataTest, onEmailSubmit, ctaText, hasSizePicker, options = [], isV2 }) => {
  const [emailEntered, setEmailEntered] = useState('')
  const [validEmail, setValidEmail] = useState(true)
  const [validSize, setValidSize] = useState(true)
  const [selectedSize, setSelectedSize] = useState(null)

  const updateEmailEntered = event => {
    event.preventDefault()
    setEmailEntered(event.target.value)
  }

  const validateEmailEntry = event => {
    event.preventDefault()

    const isValidEmail = isEmail(emailEntered)
    const isValidSize = hasSizePicker ? selectedSize : true
    setValidSize(isValidSize)
    setValidEmail(isValidEmail)

    if (isValidEmail && isValidSize) {
      if (hasSizePicker) {
        onEmailSubmit(emailEntered, selectedSize)
      } else {
        onEmailSubmit(emailEntered)
      }
    }
  }

  const selectProps = {
    options,
    placeholder: 'Size',
    value: selectedSize,
    onChange: event => {
      setSelectedSize(event.target.value)
    },
    error: !validSize && 'Please select a size'
  }

  const Wrapper = hasSizePicker ? Styled.DeliveryEmail : 'div'
  const sizeHeading = 'Size out of stock?'
  const enterEmailMessage = hasSizePicker ? 'Email address' : 'Enter email address'
  const emailHeader = 'Enter your email address and we will let you know if we get more stock in your area.'

  return (
    <Wrapper>
      {hasSizePicker && (
        <Styled.Heading data-test={`${dataTest}-size-picker-heading`}>
          <InfoIcon width='24px' height='24px' aria-hidden='true' />
          {sizeHeading}
        </Styled.Heading>
      )}

      <Styled.Copy>{emailHeader}</Styled.Copy>

      <Styled.Form
        onSubmit={event => {
          validateEmailEntry(event)
        }}
        data-test={`${dataTest}-form`}
      >
        {hasSizePicker && <Styled.Select {...selectProps} />}
        <Styled.Input
          isV2={isV2}
          type='email'
          id='email'
          aria-label='Enter your email address'
          value={emailEntered}
          onChange={updateEmailEntered}
          placeholder={enterEmailMessage}
          name='email'
          autoComplete='on'
          error={getErrorMessage(validEmail)}
          data-test={`${dataTest}-submit-input`}
          buttonOptions={{
            text: ctaText,
            type: 'submit',
            show: true,
            kind: 'secondary',
            'data-test': `${dataTest}-submit-button`
          }}
          onKeyPress={event => {
            if (event.key === 'Enter') {
              validateEmailEntry(event)
            }
          }}
        />
      </Styled.Form>
    </Wrapper>
  )
}

DeliveryEmailForm.propTypes = {
  /**
   * Required prop to pass through when valid email is entered
   */
  onEmailSubmit: PropTypes.func,
  /**
   * Optional prop to pass for data-test attribute for e2e testing
   */
  dataTest: PropTypes.string,
  /**
   * Optional prop if it is version 2
   */
  isV2: PropTypes.bool
}

DeliveryEmailForm.defaultProps = {
  dataTest: 'fulfillment-delivery-email'
}

export default DeliveryEmailForm
